import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export class PageErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Sayfa hatası:", error, info?.componentStack);
  }

  retry = () => this.setState({ error: null });

  dismiss = () => {
    this.props.onDismiss?.();
    this.setState({ error: null });
  };

  render() {
    if (!this.state.error) return this.props.children;
    const box = (
      <div className="card" data-testid="page-error-boundary" role="alert" style={{ padding: 32, margin: this.props.overlay ? 0 : "24px 0", maxWidth: 520, marginInline: "auto", textAlign: "center", borderColor: "#fecaca", background: "var(--card, #fff)" }}>
        <AlertTriangle size={32} color="#dc2626" style={{ marginBottom: 12 }} />
        <h3 style={{ margin: "0 0 6px" }}>{this.props.title || "Bu bölüm yüklenirken bir sorun oluştu"}</h3>
        <p className="muted" style={{ margin: "0 0 18px" }}>Uygulamanın geri kalanı çalışmaya devam ediyor. Tekrar deneyebilir veya başka bir sayfaya geçebilirsiniz.</p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <button className="primary-button" data-testid="page-error-retry-button" onClick={this.retry}><RefreshCw size={15} /> Tekrar dene</button>
          {this.props.onDismiss && <button className="outline-button" data-testid="page-error-dismiss-button" onClick={this.dismiss}>Kapat</button>}
          <button className="outline-button" data-testid="page-error-reload-button" onClick={() => window.location.reload()}>Sayfayı yenile</button>
        </div>
        <details style={{ marginTop: 16, fontSize: 12, color: "#64748b" }}>
          <summary data-testid="page-error-details-toggle">Teknik detay</summary>
          <code data-testid="page-error-message">{String(this.state.error?.message || this.state.error)}</code>
        </details>
      </div>
    );
    if (!this.props.overlay) return box;
    return (
      <div data-testid="page-error-overlay" style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(15,23,42,.45)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
        {box}
      </div>
    );
  }
}
